import { CommandPalette, type Command } from '@edupra/shell';

/**
 * Platform-admin command palette commands.
 *
 * Keep these scoped to operator destinations — no tenant routes, no
 * year-switching. Agents 5 and 7 will extend this list as they land
 * their screens.
 */
const COMMANDS: Command[] = [
  // Platform
  { group: 'Platform', title: 'Overview', to: '/overview', keywords: 'dashboard kpis home' },
  { group: 'Platform', title: 'Tenants', to: '/tenants', keywords: 'schools clients accounts' },
  { group: 'Platform', title: 'Operators', to: '/operators', keywords: 'staff team users platform-users' },

  // Operations
  { group: 'Operations', title: 'Audit Log', to: '/audit', keywords: 'history events trail' },
  { group: 'Operations', title: 'Impersonation Sessions', to: '/impersonation', keywords: 'sudo as login-as active grants' },

  // Configuration
  { group: 'Configuration', title: 'Feature Flags', to: '/feature-flags', keywords: 'flags toggles experiments' },
  { group: 'Configuration', title: 'Billing', to: '/billing', keywords: 'plans invoices revenue' },
  { group: 'Configuration', title: 'Settings', to: '/settings', keywords: 'config preferences' },
];

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AdminCommandPalette({ open, onClose }: Props) {
  return (
    <CommandPalette
      open={open}
      onClose={onClose}
      commands={COMMANDS}
      brandLabel="Edupra Admin · ⌘K"
      placeholder="Jump to a console section…"
    />
  );
}
